<template>
  <div>
    <div class="inputCard">
      <header>Team Page Main</header>
      <div class="content">
        <div class="cardRow w3-padding-8">
          <label class="w3-label">Team Page Type</label>
          <select class="w3-select w3-border" v-model="state.siteData.pages.team.type">
            <!-- <option value="basic">Basic</option> -->
            <!-- <option value="advanced">Advanced</option> -->
            <option value="dropdown">Dropdown</option>
          </select>
        </div>
        <div class="cardRow w3-padding-8">
          <label class="w3-label">Page Enabled?</label>
          <div class="w3-right-align">
            <label class="switch">
              <input type="checkbox" v-model="state.siteData.pages.team.enabled">
              <span class="slider"></span>
            </label>
          </div>
        </div>
        <div class="cardRow w3-padding-8">
          <label>Page URL</label>
          <input v-model="state.siteData.pages.team.url" class="w3-input w3-border" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  var dataStore = require('@/dataStore').default
  import Editor from '@tinymce/tinymce-vue'

  export default {
    name: 'cmsPagesTeam',
    data() {
      return {
        state: dataStore.state
      }
    },
    components: {
      'tinymce-editor': Editor
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/cms/pages/team/cmsPagesTeam.vue